import type { CustomIconProps } from '../types';

const SnailIcon = ({ width, height, color }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '12'}
        height={height || '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <circle cx="6" cy="6" r="6" fill={color || '#FF8A01'} />
    </svg>
);

export default SnailIcon;
